import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-autogen",
  "use": "icon-leo-autogen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-autogen\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"224\" y=\"160\" width=\"576\" height=\"704\" rx=\"32\" /><path d=\"M320 288h384v48H320zM320 384h320v48H320zM320 480h288v48H320z\" fill=\"#fff\" /><path d=\"M640 640l128 64-128 64V640z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-autogen.svg
// module id = TX11
// module chunks = 491